export const personalizedSectionBuilderRefName = 'personalizedSectionBuilderRef';

export const personalizedSectionBuilderRefProjection = `{
    _id,
    excludeFromTranslation,
    variations[],
    personalizationDimension {
        reference->
    }
}`;

export const personalizedSectionBuilderRefQuery = groq`*[_id == $_id && _type == "personalizedSectionBuilder"][0]
 ${personalizedSectionBuilderRefProjection}
`;
